import React from "react";
import {
  composeRenderProps,
  Heading,
  Dialog as RACDialog,
  Modal as RACModal,
  ModalOverlay as RACModalOverlay,
} from "react-aria-components";
import { Effect } from "./Effects";

export interface IModalProps {
  children: React.ReactNode;
  isOpen?: boolean;
  onClose?: () => void;
  className?: string;
  size?: "small" | "medium" | "large" | "xlarge" | "full";
  title: string;
  isDismissable?: boolean;
}

export function Modal({
  children,
  isOpen,
  onClose,
  className,
  size = "medium",
  title,
  isDismissable = false,
}: IModalProps) {
  const sizeToStyle: Record<
    NonNullable<IModalProps["size"]>,
    React.CSSProperties
  > = {
    small: { width: 420, maxWidth: "90vw" },
    medium: { width: 640, maxWidth: "95vw" },
    large: { width: 840, maxWidth: "95vw" },
    xlarge: { width: 1100, maxWidth: "98vw" },
    full: { width: "85vw" },
  };

  return (
    <RACModalOverlay
      isOpen={isOpen}
      isDismissable={isDismissable}
      onOpenChange={(open) => !open && onClose?.()}
      className={
        composeRenderProps(
          className as any,
          (cn: string, { isEntering, isExiting }: any) =>
            [
              "fixed inset-0 z-[58] flex items-center justify-center overflow-y-auto bg-backgroundOverlay backdrop-blur-[4px] p-4",
              isEntering && "animate-in fade-in ease-out duration-base",
              isExiting && "animate-out fade-out ease-in duration-fast",
              cn,
            ]
              .filter(Boolean)
              .join(" "),
        ) as any
      }>
      <RACModal className="bg-transparent outline-none">
        <Effect effect="zoom-in" active={isOpen}>
          <div className="shrink-0" style={sizeToStyle[size]}>
            <RACDialog className="bg-backgroundTertiary border border-borderTertiary rounded-xl shadow-lg w-full max-w-none max-h-[90vh] overflow-y-auto outline-none">
              <Heading slot="title" className="sr-only">
                {title}
              </Heading>
              {children}
            </RACDialog>
          </div>
        </Effect>
      </RACModal>
    </RACModalOverlay>
  );
}
